export const Tips = [
  {
    title: "Solid Application",
    description:
      "A holistic application backed by strong academic records, compelling essays, and excellent recommendation letters will make all the difference.",
  },
  {
    title: "Early Preparation",
    description:
      "Plan early so as to meet the deadlines and have all the documents required in place.",
  },
  {
    title: "Do the research",
    description:
      "On the various universities and what they look for. Some may have distinct criteria or even be quite flexible in the admission process.",
  },
  {
    title: "Consult Experts",
    description:
      "You may get in touch with educational counsellors or agencies who deal with overseas education for reaching out to help in the application process.",
  },
];
